export default __webpack_public_path__ + "static/media/sound.35ac5c01.svg";